import { all, takeLatest, retry, put, select } from 'redux-saga/effects';
import { notifyActions, notifySelector } from '$store/notify/index';
import { Api } from '$api';
import { batchActions } from '$store';
import { mainActions } from '$store/main';
import { postsActions } from '$store/posts';
import { followersActions } from '$store/followers';
import { LoadNotifyAction } from '$store/notify/interface';
import { NotifyModelType } from '$store/models';
import router from '$navigation/router';
// import {NOTIFY_API_RESPONSE} from "$store/notify/response.dev";

let loadMoreKey = 0;

function* loadWorker() {
  try {
    loadMoreKey = Date.now();

    const params = router.getState().params;
    let type = params.tab || '';
    if (type === NotifyModelType.ALL) {
      type = '';
    }

    const from = parseInt(params.from || '0', 10);
    const to = parseInt(params.to || '0', 10);

    const data = yield retry(Infinity, 3000, Api.post, '/notify', { type, from, to });

    yield put(
      batchActions(
        mainActions.setUsers(data.users),
        postsActions.setPosts(data.posts),
        mainActions.setGroups(data.groups),
        notifyActions.setItems(data.items),
        mainActions.setHasNotify(false),
        followersActions.setFollowing(data.followed),
        notifyActions.setNextFrom(data.nextFrom),
        notifyActions.setLoadingMore(false),
      ),
    );
  } catch (e) {}
}

function* loadMoreWorker() {
  try {
    const key = Date.now();
    loadMoreKey = key;

    const params = router.getState().params;
    let type = params.tab || '';
    if (type === NotifyModelType.ALL) {
      type = '';
    }

    const from = parseInt(params.from || '0', 10);
    const to = parseInt(params.to || '0', 10);

    const { nextFrom } = yield select(notifySelector);
    const data = yield retry(3, 3000, Api.post, '/notify', {
      type,
      from,
      to,
      startFrom: nextFrom,
    });
    if (loadMoreKey !== key) {
      return;
    }

    yield put(
      batchActions(
        mainActions.setUsers(data.users),
        postsActions.setPosts(data.posts),
        mainActions.setGroups(data.groups),
        notifyActions.addItems(data.items),
        mainActions.setHasNotify(false),
        followersActions.setFollowing(data.followed),
        notifyActions.setNextFrom(data.nextFrom),
        notifyActions.setLoadingMore(false),
      ),
    );
  } catch (e) {
    yield put(notifyActions.setLoadingMore(false));
  }
}

export function* notifySaga() {
  yield all([
    takeLatest(notifyActions.load, loadWorker),
    takeLatest(notifyActions.loadMore, loadMoreWorker),
  ]);
}
